import { render, staticRenderFns } from "./TestPortalRegis.vue?vue&type=template&id=313fc6ff&scoped=true"
import script from "./TestPortalRegis.vue?vue&type=script&lang=js"
export * from "./TestPortalRegis.vue?vue&type=script&lang=js"
import style0 from "./TestPortalRegis.vue?vue&type=style&index=0&id=313fc6ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313fc6ff",
  null
  
)

export default component.exports